import React, { useState, useEffect, useCallback, useContext } from "react";
import { TableContext } from "../table";
import { Box, Grid } from "@material-ui/core";
import { Actions } from "../../../screens/request/components/actions";
import { UPDATE_FILTERS_DATA } from "../state";
import { createStyles, Theme, WithStyles } from "@material-ui/core/styles";
import { Search } from "./search-filters";
import { Form } from "@components";
import { AnnouncementModelForForm } from "@api/types/announcements";
import { AnnouncementDetail } from "../../../screens/dashboard/admin/maintenance/announcements/detail";
import { EditorState } from "draft-js";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  onClickAdd: () => void;
}

export const AnnouncementsToolbar: React.FC<Props> = () => {
  const [openAnnouncement, setOpenAnnouncement] = useState<boolean>(false);
  const { dispatch } = useContext(TableContext);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  const form = Form.useManager<AnnouncementModelForForm>({
    id: 0,
    title: "",
    message: EditorState.createEmpty(),
    datePosted: null,
    postedBy: "",
    isActive: false,
  });

  useEffect(() => {
    if (!openAnnouncement) {
      // clear form if modal has closed
      form.reset();
    }
  }, [openAnnouncement]);

  function handleClickOpen() {
    setOpenAnnouncement(true);
  }

  const isShowModal = openAnnouncement ? (
    <AnnouncementDetail
      form={form}
      open={openAnnouncement}
      onCancel={() => {
        setOpenAnnouncement(false);
      }}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Announcement
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Title"}
          ></Search>
        </Grid>
      </Grid>
      {isShowModal}
    </Box>
  );
};
